import { render, staticRenderFns } from "./imServer.vue?vue&type=template&id=53c86fea"
import script from "./imServer.vue?vue&type=script&lang=js"
export * from "./imServer.vue?vue&type=script&lang=js"
import style0 from "./imServer.vue?vue&type=style&index=0&id=53c86fea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports